/** 페이지별 이미지 파일은 마케팅 운영 경로에 먼저 업로드한 뒤 앱을 배포한다. */
export const PAGE_ASSET_PREFIXES = {
    features: 'https://us.wink.co.kr/marketing/homepage/Main/PC/feature/images/261027',
    kor: 'https://s.wink.co.kr/marketing/homepage/Main/PC/subject/kor/261103',
    math: 'https://s.wink.co.kr/marketing/homepage/Main/PC/subject/math/261103',
    en: 'https://s.wink.co.kr/marketing/homepage/Main/PC/subject/en/261103',
    choice: 'https://s.wink.co.kr/marketing/homepage/Main/PC/subject/choice/261103',
} as const;

type PageAssetGroup = keyof typeof PAGE_ASSET_PREFIXES;

// 페이지별 버전 폴더에서 페이지 접두사와 평탄화한 파일명을 사용한다.
export const pageAsset = (page: PageAssetGroup, filename: string): string =>
    `${PAGE_ASSET_PREFIXES[page]}/${page}-${filename.replace(/^\/+/, '').replace(/\//g, '-')}`;
